import { Component, OnInit } from '@angular/core'; 
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { CompaniesService } from 'src/app/services/yardscore-services/companies.service';
@Component({
  selector: 'app-company-create',
  templateUrl: './company-create.component.html',
  styleUrls: ['./company-create.component.css']
})
export class CompanyCreateComponent implements OnInit {
  companiesForm: FormGroup;
  isSubmitting = false;
  errors: any = {};  

  constructor(
    private companyService: CompaniesService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.companiesForm = this.fb.group({
      name: ['', Validators.required],
      vatNumber: ['', Validators.required],
      type: ['', Validators.required], 
    });
  }

  ngOnInit(): void {}

  createCompany(): void {
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    const formData = this.companiesForm.getRawValue();
    
    const newCompany = {
      name: formData.name,
      vatNumber: formData.vatNumber,
      type: formData.type
    };

    this.companyService.createCompanyV2(newCompany).pipe(
      catchError(error => {
        this.errors = {};

        if (error.status === 400) {
          if (Array.isArray(error.error)) {
            error.error.forEach((errMessage: string) => {
              if (errMessage.includes('Name')) {
                this.errors.name = this.errors.name || [];
                this.errors.name.push(errMessage);
              } else if (errMessage.includes('VatNumber')) {
                this.errors.vatNumber = this.errors.vatNumber || [];
                this.errors.vatNumber.push(errMessage);
              } else if (errMessage.includes('Type')) {
                this.errors.type = this.errors.type || [];
                this.errors.type.push(errMessage);
              } else {
                this.errors.general = this.errors.general || [];
                this.errors.general.push(errMessage);
              }
            });
          } else if (typeof error.error === 'string') {
            this.errors.general = [error.error];
          } else {
            this.toastr.error('An unexpected error occurred.');
          }
        } else {
          this.toastr.error('Failed to create company.');
        }
        return [];
      })
    ).subscribe(
      response => {
        this.toastr.success('Company created successfully!');
        this.router.navigate(['/homeAdmin/v2/companies']);
      },
      error => {
        console.error('Error creating company:', error);
      }
    ).add(() => {
      this.isSubmitting = false;
    });
  }
}